import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { RulesManager } from './RulesManager';
import { ApprovalsInbox } from './ApprovalsInbox';
import { IADCompanySettings } from '../iad/IADCompanySettings';
import { ProjectsPanel } from '../execution/ProjectsPanel';
import { HistoricalPanel } from '../historical/HistoricalPanel';
import { MaterialityPanel } from '../materiality/MaterialityPanel';
import { AttentionPanel } from '../attention/AttentionPanel';
import { MemoryPanel } from '../memory/MemoryPanel';

const GovernanceV2Panel = ({ companyId, user }) => (
  <div className="space-y-6 p-8" data-testid="governance-v2-panel">
    <div className="flex items-center gap-3">
      <ShieldCheck className="h-7 w-7 text-emerald-600" />
      <div>
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Decisiones Gobernadas</h2>
        <p className="text-sm text-slate-500">Reglas institucionales y aprobaciones humanas sobre las decisiones que proponen los agentes.</p>
      </div>
    </div>
    {!companyId ? <p className="text-sm text-slate-400" data-testid="governance-v2-no-company">Selecciona una empresa.</p> : (
      <Tabs defaultValue="approvals">
        <TabsList>
          <TabsTrigger value="approvals" data-testid="governance-v2-tab-approvals">Aprobaciones</TabsTrigger>
          <TabsTrigger value="rules" data-testid="governance-v2-tab-rules">Reglas institucionales</TabsTrigger>
          <TabsTrigger value="iad" data-testid="governance-v2-tab-iad">Metodologías IAD</TabsTrigger>
          <TabsTrigger value="projects" data-testid="governance-v2-tab-projects">Proyectos</TabsTrigger>
          <TabsTrigger value="historical" data-testid="governance-v2-tab-historical">Histórico</TabsTrigger>
          <TabsTrigger value="materiality" data-testid="governance-v2-tab-materiality">Alertas</TabsTrigger>
          <TabsTrigger value="attention" data-testid="governance-v2-tab-attention">Prioridad Ejecutiva</TabsTrigger>
          <TabsTrigger value="memory" data-testid="governance-v2-tab-memory">Memoria</TabsTrigger>
        </TabsList>
        <TabsContent value="approvals" className="mt-4"><ApprovalsInbox companyId={companyId} user={user} /></TabsContent>
        <TabsContent value="rules" className="mt-4"><RulesManager companyId={companyId} /></TabsContent>
        <TabsContent value="iad" className="mt-4"><IADCompanySettings companyId={companyId} /></TabsContent>
        <TabsContent value="memory" className="mt-4"><MemoryPanel key={companyId} companyId={companyId} role={user?.role} /></TabsContent>
        <TabsContent value="attention" className="mt-4"><AttentionPanel key={companyId} companyId={companyId} userEmail={user?.email} /></TabsContent>
        <TabsContent value="materiality" className="mt-4"><MaterialityPanel key={companyId} companyId={companyId} role={user?.role} /></TabsContent>
        <TabsContent value="historical" className="mt-4"><HistoricalPanel key={companyId} companyId={companyId} /></TabsContent>
        <TabsContent value="projects" className="mt-4"><ProjectsPanel key={companyId} companyId={companyId} role={user?.role} currentUserId={user?.id} /></TabsContent>
      </Tabs>
    )}
  </div>
);

export default GovernanceV2Panel;
